<template>
  <div
    class="border border-blue"
    style="border-radius: 20px; height: 378px; max-height: 378px;"
  >
    <div v-if="editor">
      <div
        class="mx-1 my-0 flex flex-row border border-dotted border-blue border-l-0 border-r-0 border-t-0"
      >
        <button
          type="button"
          @click="
            editor
              .chain()
              .focus()
              .undo()
              .run()
          "
        >
          <UndoIcn />
        </button>
        <button
          type="button"
          @click="
            editor
              .chain()
              .focus()
              .redo()
              .run()
          "
        >
          <RedoIcn />
        </button>
        <button
          type="button"
          @click="
            editor
              .chain()
              .focus()
              .toggleBold()
              .run()
          "
          :class="{ 'is-active': editor.isActive('bold') }"
        >
          <BoldIcn />
        </button>
        <button
          type="button"
          @click="
            editor
              .chain()
              .focus()
              .toggleUnderline()
              .run()
          "
          :class="{ 'is-active': editor.isActive('underline') }"
        >
          <UnderlineIcn />
        </button>
        <button
          type="button"
          @click="
            editor
              .chain()
              .focus()
              .toggleStrike()
              .run()
          "
          :class="{ 'is-active': editor.isActive('strike') }"
        >
          <StrikeIcn />
        </button>
        <button
          type="button"
          @click="
            editor
              .chain()
              .focus()
              .toggleBulletList()
              .run()
          "
          :class="{ 'is-active': editor.isActive('bulletList') }"
        >
          <OlIcn />
        </button>
        <button
          type="button"
          @click="
            editor
              .chain()
              .focus()
              .toggleOrderedList()
              .run()
          "
          :class="{ 'is-active': editor.isActive('orderedList') }"
        >
          <UlIcn />
        </button>
      </div>
    </div>
    <editor-content :editor="editor" spellcheck="false" />
  </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'

import UndoIcn from '@/assets/icons/undo.svg?inline'
import RedoIcn from '@/assets/icons/redo.svg?inline'
import BoldIcn from '@/assets/icons/bold.svg?inline'
import UnderlineIcn from '@/assets/icons/underline.svg?inline'
import StrikeIcn from '@/assets/icons/strike.svg?inline'
import OlIcn from '@/assets/icons/ol.svg?inline'
import UlIcn from '@/assets/icons/ul.svg?inline'

export default {
  components: {
    EditorContent,
    UndoIcn,
    RedoIcn,
    BoldIcn,
    UnderlineIcn,
    StrikeIcn,
    OlIcn,
    UlIcn,
  },

  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editor: null,
    }
  },

  watch: {
    modelValue(value) {
      // HTML

      // 文字列入力後に文字列を削除した場合v-modelの中に[<p></p>]が残ってしまい、validationを通過してしまうためvalueを初期化する
      if (value === '<p></p>') {
        value = ''
        this.$emit('update:modelValue', value)
      }
      const isSame = this.editor.getHTML() === value
      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },
  },

  mounted() {
    this.editor = new Editor({
      extensions: [StarterKit, Underline],
      content: this.modelValue,
      onUpdate: () => {
        // HTML
        this.$emit('update:modelValue', this.editor.getHTML())

        // JSON
        // this.$emit('update:modelValue', this.editor.getJSON())
      },
    })
  },

  beforeUnmount() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss" scoped>
button {
  padding: 10px 10px;

  svg {
    fill-opacity: 0.8;
  }

  &.is-active {
    svg {
      fill-opacity: 1;
    }
  }
}
</style>

<style lang="scss">
.ProseMirror {
  margin: 8px !important;
  height: 326px !important;
  max-height: 326px !important;
  overflow: scroll !important;
  outline: none !important;
}
/* Basic editor styles */
.ProseMirror {
  > * + * {
    margin-top: 0.75em;
  }

  ul,
  ol {
    padding: 0 2rem !important;
  }

  ul {
    list-style: disc !important;
  }

  ol {
    list-style: auto !important;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
  }

  code {
    background-color: rgba(#616161, 0.1);
    color: #616161;
  }

  pre {
    background: #0d0d0d;
    color: #fff;
    font-family: 'JetBrainsMono', monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      color: inherit;
      padding: 0;
      background: none;
      font-size: 0.8rem;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0d0d0d, 0.1);
  }

  hr {
    border: none;
    border-top: 2px solid rgba(#0d0d0d, 0.1);
    margin: 2rem 0;
  }
}
</style>
